import {
  Brand,
  NavbarStyled,
  UserDropdownMenu,
  UserDropdownStyled,
} from "./navbar.styles";
import { useState } from "react";
import { NavbarProps } from "./types";
import MenuDropdown from "../menu/menu";
import { Typography } from "@mui/material";
import { useLocation, useNavigate, Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { getNavbarOptions } from "./navbar.utils";
import settingsIcon from "../../assets/icons/settings.svg";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { clearUserSession, getSessionUser } from "../../utils/common-utils";
import InviteUserModal from "./invite-user-modal/invite-user-modal";

const UserDropdown: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpened, setMenuOpened] = useState<boolean>(false);
  const { name, email } = getSessionUser();
  const [modalState, setModalState] = useState<{
    inviteUser: boolean;
  }>({
    inviteUser: false,
  });

  const handleLogout = () => {
    clearUserSession();
    navigate("/login");
  };
  const handleInviteUser = () => {
    setModalState((state) => {
      return { ...state, inviteUser: true };
    });
  };
  const resetModalState = () => {
    setModalState((state) => {
      return { ...state, inviteUser: false };
    });
  };

  const handleSwitchRole = () => {
    if (location.pathname.includes("admin")) navigate("/dashboard");
    else navigate("/admin");
  };

  const dropdownData = getNavbarOptions({
    handleLogout,
    handleInviteUser,
    currentRoute: location.pathname,
    handleSwitchRole,
  });
  return (
    <div>
      <UserDropdownStyled>
        <MenuDropdown
          items={dropdownData}
          linkToOpen={
            <UserDropdownMenu>
              <span>
                <Typography className="user-name">{name}</Typography>
                <Typography className="user-email">{email}</Typography>
              </span>
              <span className="caret-container">
                {!menuOpened && <ArrowDropDown />}
                {menuOpened && <ArrowDropUp />}
              </span>
            </UserDropdownMenu>
          }
          isOpened={(state: boolean) => setMenuOpened(state)}
        />
      </UserDropdownStyled>
      <InviteUserModal open={modalState.inviteUser} onClose={resetModalState} />
    </div>
  );
};

const Navbar: React.FC<NavbarProps> = ({ isLoggedIn }) => {
  return (
    <NavbarStyled sx={{ backgroundColor: isLoggedIn ? "#ffffff" : "" }}>
      <Brand>
        {isLoggedIn ? (
          <Link to="/dashboard">
            <img src={logo} alt="Logo" />
          </Link>
        ) : (
          <img src={logo} alt="Logo" />
        )}
        <Typography className="web-title">Chasing Tails</Typography>
      </Brand>
      {isLoggedIn && <UserDropdown />}
    </NavbarStyled>
  );
};

export default Navbar;
